<template>
    <a-modal
        centered
        :visible="visible"
        title="修改订单金额"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="480"
        :after-close="after_close"
    >
        <!-- <a-alert
            message="请注意"
            description="订单金额必须=订单首款+订单尾款，如果客户已经支付了首款，那么这里的订单首款将禁止修改。"
            type="info"
            show-icon
            style="margin-bottom:24px"
        /> -->

        <a-form-model :model="form" ref="order-price" :rules="rules">
            <a-form-model-item label="订单总金额" prop="amount">
                <a-input v-model="form.amount"></a-input>
            </a-form-model-item>

            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-model-item label="买家首款" prop="amount_deposit">
                        <a-input v-model="form.amount_deposit"></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="卖家首款" prop="amount_deposit">
                        <a-input v-model="form.amount_deposit_seller"></a-input>
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-model-item label="买家尾款" prop="amount_retainage">
                        <a-input v-model="form.amount_retainage"></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="卖家尾款" prop="amount_retainage_seller">
                        <a-input v-model="form.amount_retainage_seller"></a-input>
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-form-model-item label="订单利润" prop="amount_profit">
                <a-input v-model="form.amount_profit"></a-input>
            </a-form-model-item>

            <a-form-model-item label="订单服务费" prop="amount_service" extra="如果不存在服务费，请填写 0">
                <a-input v-model="form.amount_service"></a-input>
            </a-form-model-item>

            <a-form-model-item label="本次修改备注" prop="remark">
                <a-textarea v-model="form.remark"></a-textarea>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        remark: null,
        amount: null,
        amount_deposit: null,
        amount_deposit_seller: null,
        amount_retainage: null,
        amount_retainage_seller: null,
        amount_profit: null,
        amount_service: null,
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
            callback: null,
        },
        data() {
            return {
                submitting: false,
                rules: {
                    remark: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    amount_deposit: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    amount_profit: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    amount_service: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    amount: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    amount_retainage: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    amount_retainage_seller: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                },
                form: null,
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        watch: {
            visible(e) {
                if (e && this.record) {
                    Object.keys(this.form).map((v) => {
                        if (Object.prototype.hasOwnProperty.call(this.record, v)) {
                            if (v != "remark") {
                                this.form[v] = this.record[v];
                            }
                        }
                    });
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["order-price"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.form.type = "confirm";

                        this.$http
                            .put("/order_trademark/" + this.record.order_no + "/update_amount", this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.cancel();
                                    this.$message.success(res.message);

                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$error({ title: "失败", centered: true, content: res.message });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },

            after_close() {
                this.$refs["order-price"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));
            },
        },
    };
</script>
